import React, { useEffect } from "react";
import { Form, Input, DatePicker } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getTrainingModuleRequestDetails, doTrainingModuleRequestCreate, doTrainingModuleRequestUpdate 
} from "../../../../redux/trainingmodulerequest/trainingModuleRequestState";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import { DATE_FORMAT, MODULE_TRAINING_REQ } from "variables/constants";
import dayjs from "dayjs";

const TrainingModuleRequestForm = ({
	recordData,
	getDetails,
	doCreate, 
	doUpdate, 
	onCancel,
	submitLabel,
	getRecord,
	...props
}) => {
	
  	const [form] = Form.useForm();
	const { recordId, mode } = props;
	const { TextArea } = Input;  	

	useEffect(() => {
		if(recordId){
			getRecord(recordId);
		}
	}, [recordId, getRecord]);

	useEffect(() => {
		if(recordData){
			form.resetFields();
			const { trainingmodule:tmr_title, tmr_summary, ...rest } = recordData;

			const initialValues = {
				...rest,
				tmr_id: recordData?.tmr_id ?? "",
				tmr_title: recordData?.tmr_title ?? "",
				tmr_summary: recordData?.tmr_summary ?? "",
				tmr_target_date: recordData?.tmr_target_date ? dayjs(recordData.tmr_target_date) : "",
			};
	        form.setFieldsValue(initialValues);

        }
    }, [recordData, form]);


  	const onSubmit = (formData) => {	
		console.log(recordData);
    	try {  
			formData.tmr_target_date = formData.tmr_target_date?.format(DATE_FORMAT);

			recordData.tmr_id > 0 ? doUpdate(formData): doCreate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Form className={mode !== "view" ? "form" : ""}
			form={form} 
			layout="vertical"
			onFinish={onSubmit}
		>   
			<FormItem
				name="tmr_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
			
			<div className="grid grid-cols-3 gap-y-2 gap-x-4 w-full">         		            	            
				<FormItem className="font-medium mb-2 col-span-3 md:col-span-2"
					name="tmr_title"
					label="Training Module Title"
					rules={[requiredField]}
					
				>
					{mode === 'edit' ?
					<Input id="tmr_title"
						className="input-field"
						maxLength={100}
						placeholder="Enter training module title"
					/>
					: <label className="text-base label-value dark:text-white">{recordData?.tmr_title}</label>
					}
				</FormItem>

				<FormItem className="font-medium mb-2 col-span-3 md:col-span-1"
					label="Target Date" 
					name="tmr_target_date"
					rules={[requiredField()]}
						>
					{mode !== "view" ?
						<DatePicker id="tmr_target_date"
						className="input-field"
						format={DATE_FORMAT}
						style={{ width: "100%" }}
							/>
						: 
					<label className="text-base label-value dark:text-white">
							{recordData?.tmr_target_date}
					</label>
						}
        		</FormItem>
					  
				<FormItem className="font-medium mb-2 col-span-3"
					name="tmr_summary"
					label="Training Summary"
					rules={[requiredField()]}
				>
					{mode === 'edit' ?
					<TextArea id="tmr_summary"
						className="input-field"
						rows={3}
						maxLength={250}
						placeholder="Enter training module summary"
					/>
					: <label className="text-base label-value dark:text-white">
						{recordData?.tmr_summary}
					</label>
					}               
				</FormItem> 
				
			</div>


			<div className="w-full flex justify-end">
				{(mode === "edit") && (
					<CrudButtons
					mode={mode}
					recordId={recordData?.tmr_id ?? 0}
					isModal={true}
					modalId={recordData?.tmr_id > 0 ? 'edit_trainingModuleRequest' : 'add_trainingModuleRequest'}
					cancelLabel="Cancel"
					doHideModal={onCancel}
					submitLabel={submitLabel}
					moduleId={MODULE_TRAINING_REQ}
					/>
				)}
				</div> 				 			
		</Form>	 	
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.trainingModuleRequest.trainingModuleRequestDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getTrainingModuleRequestDetails(id)),
  	doCreate: (data) => dispatch(doTrainingModuleRequestCreate(data)),
  	doUpdate: (data) => dispatch(doTrainingModuleRequestUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingModuleRequestForm);
